import { render, staticRenderFns } from "./ResponsibilityLineMenu.vue?vue&type=template&id=058b9581&scoped=true"
import script from "./ResponsibilityLineMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityLineMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityLineMenu.vue?vue&type=style&index=0&id=058b9581&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b9581",
  null
  
)

export default component.exports